import { memo, useEffect, useState } from "react";
import { Button, Col, Form, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";

function ModalCadastro({
    id,
    aoFechar
}) {
    const [carregando, alterarCarregando] = useState(false);
    const [dados, alterarDados] = useState({
        id: null,
        nome: '',
        email: ''
    });
    const [nomeResponsavel, alterarNomeResponsavel] = useState(null);

    // consulta email via id
    async function consultarId() {
        // ativa o carregamento
        alterarCarregando(true);

        try {

            // consulta email pelo id
            const { data } = await axios.get(`/emailsListaNegra/${id}`);
            
            // altera dados
            alterarDados({
                id: data.dados.id,
                nome: data.dados.nome,
                email: data.dados.email
            });
            alterarNomeResponsavel(data?.dadosUsuario?.nome);
        } catch(e) {
            console.error(e);
        } finally {
            alterarCarregando(false);
        }
    }

    // cadastra/edita email
    async function salvar() {
        // ativa o carregamento
        alterarCarregando(true);

        try {
            // salva email
            await axios.post('/emailsListaNegra', {
                dados
            });
            
            // volta para a lista
            aoFechar(true);
        } catch(e) {
            console.error(e);
            
            const response = e?.response;

            // caso retornou erro
            if(response?.data && Object.keys(response.data)) {

                // resgata primeira chave do erro
                const erroChave = Object.keys(response.data)[0];
                
                // mensagem de erro
                toast(<>
                    <div
                        style={{ background: '#ff6271' }}
                    >
                        <div className="toast-header">
                            <strong className="mr-auto">Erro ao salvar!</strong>
                            <button
                                className="ml-2 mb-1 close btn-outline-light outline-0"
                            >
                            </button>
                        </div>
                        <div className="toast-body text-light">
                            <p>{response.data[erroChave]}</p>                            
                        </div>
                    </div>
                </>);

            }
        } finally {
            // desativa o carregamento
            alterarCarregando(false);
        }
    }
    
    useEffect(() => {   
        if(id) consultarId();
    }, [])

    return (
        <Modal
            show
            onExited={aoFechar}
            onHide={aoFechar}
            size={'md'}
            centered
            contentClassName="mb-5"
        >
            <Modal.Header className='border-0'>
                <Modal.Title className='fw-bold'>
                    {id ? 'Edição' : 'Cadastro'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group>
                    <Form.Row>
                        <Col>
                            <Form.Label>Nome</Form.Label>
                            <Form.Control
                                value={dados.nome}
                                name='nome'
                                disabled={carregando}
                                onChange={e => alterarDados({
                                    ...dados,
                                    nome: e.target.value
                                })}
                            />
                        </Col>
                    </Form.Row>
                </Form.Group>
                <Form.Group>
                    <Form.Row>
                        <Col>
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                value={dados.email}
                                name='email'
                                disabled={carregando}
                                placeholder="Ex: xxxxxx@gmail.com"
                                as={'input'}
                                type="email"
                                onKeyDown={e => {
                                    if(e.key === 'Enter') salvar();
                                }}
                                onChange={e => alterarDados({
                                    ...dados,
                                    email: e.target.value
                                })}
                            />
                        </Col>
                    </Form.Row>
                </Form.Group>
                {nomeResponsavel && (
                    <Form.Group>
                        <Form.Row>
                            <Col>
                                <Form.Label>Responsável</Form.Label>
                                <Form.Control
                                    value={nomeResponsavel}
                                    disabled
                                />
                            </Col>
                        </Form.Row>
                    </Form.Group>
                )}
            </Modal.Body>
            <Modal.Footer className='border-0 justify-content-between'>
                <Button
                    variant={'padrao'}
                    onClick={aoFechar}
                    disabled={carregando}
                >
                    <span>Cancelar</span>
                </Button>
                <Button
                    onClick={salvar}
                    variant='success'
                    disabled={carregando}
                >
                    {carregando ? 
                        <>
                            <FontAwesomeIcon className="icone" pulse icon={["fas", 'spinner']} />
                            <span>Carregando</span>
                        </> : 
                        <span>{id ? 'Editar' : 'Cadastrar'}</span>
                    }
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default memo(ModalCadastro);